import React from 'react';
import { getDisplayLabel, WidgetProps } from '@rjsf/utils';
import { TextField } from '@mui/material';
import useLinkifiedLabel from './useLinkifiedLabel';
import validator from '@rjsf/validator-ajv8';

const TextWidget = ({
  id,
  placeholder,
  required,
  readonly,
  disabled,
  type,
  label,
  value,
  onChange,
  onBlur,
  onFocus,
  autofocus,
  options,
  schema,
  uiSchema,
  rawErrors = [],
  formContext,
  registry,
  ...textFieldProps
}: WidgetProps) => {
  const _onChange = ({ target: { value: val } }: React.ChangeEvent<HTMLInputElement>) => onChange(val === '' ? options.emptyValue : val);
  const _onBlur = ({ target: { value: val } }: React.FocusEvent<HTMLInputElement>) => onBlur(id, val);
  const _onFocus = ({ target: { value: val } }: React.FocusEvent<HTMLInputElement>) => onFocus(id, val);

  const { rootSchema } = registry;
  const shouldDisplayLabel = getDisplayLabel(validator, schema, uiSchema, rootSchema);
  const displayLabel = useLinkifiedLabel(label);
  const inputType = (type || schema.type) === 'string' ? 'text' : `${type || schema.type}`;
  console.log('display---', shouldDisplayLabel);
  return (
    <TextField
      id={id}
      placeholder={placeholder}
      label={shouldDisplayLabel ? displayLabel || schema.title : false}
      required={required}
      disabled={disabled || readonly}
      type={inputType as string}
      value={value || value === 0 ? value : ''}
      autoFocus={autofocus}
      error={rawErrors.length > 0}
      onChange={_onChange}
      onBlur={_onBlur}
      onFocus={_onFocus}
      {...textFieldProps}
      InputLabelProps={{
        shrink: true,
      }}
      inputProps={{ 'data-testid': 'root_test_text_field' }}
    />
  );
};

export default TextWidget;
